import jsxElem from "jsx-no-react";
import copy from 'copy-to-clipboard';

const CopyToClipboard = (text) => {
    copy(text, {
        format: 'text/plain',
        onCopy: () => {
            $('.bmui-copy').addClass('copied');
            setInterval(() => $('.bmui-copy').removeClass('copied'), 3000);
        },
    });
};

export {
    CopyToClipboard
};